import { SettingsBackendClient } from "../services/SettingsService.ts";
import router from "../router/index.ts";
import { baseUrl } from "../../app.config";
import { loadLocaleMessages } from '../plugins/i18n.ts';
import type { I18n } from 'vue-i18n';
import { useLanguageStore } from "../store";

type I18n = typeof I18n;

const _settings = new SettingsBackendClient(baseUrl);
export function setupMiddlewareLanguage(i18n: I18n) {
  router.beforeEach(async () => {
    const languageStore = useLanguageStore();
    try {
      const result = await _settings.userSettingsGetSettings("language", "1");
      if (result.status === 200) {
        if(result.result[0].value === 'en') {
          loadLocaleMessages(i18n, result.result[0].value);
        }
        const language = result.result[0].value ?? 'de';
        languageStore.setLanguage(language);
        i18n.global.locale.value = language;
      } else if (result.status === 401) {
        languageStore.setLanguage('de');
        i18n.global.locale.value = 'de';
      }
    } catch (err: unknown) {
      languageStore.setLanguage("de");
      i18n.global.locale.value = 'de';
    }
  });

}
